<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" class="agoda-logo-container">
  <img src="/assets/iconography/agoda.svg" class="agoda-logo" />
  <h2 class="nomargin">Set {{ 'CORE.PRODUCT_NAME' | transloco }} up as your channel manager</h2>
</div>

<div class="info-box">
  <div class="info-container">
    <div class="instructions">
      <h3>Follow these steps to connect Hospitable as your channel manager in Agoda:</h3>
      <ol>
        <li>In Agoda Homes (or Agoda YCS), go to the property you wish to connect to Hospitable.</li>
        <li>
          At the top of the page, go to
          <strong>Rates and Availability >> Pricing</strong>
          .
        </li>
        <li>
          In the Channel Manager section, select
          <strong>Hospitable</strong>
          from the drop-down box.
        </li>
        <li>
          Click
          <strong>Save</strong>
          .
        </li>
      </ol>
      <p>Once you've completed these steps, Hospitable will be set as your channel manager in Agoda.</p>
      <p>You will need to do this step for each property you wish to connect to Hospitable.</p>
    </div>
  </div>
</div>

<div class="button-container" fxLayout fxLayoutGap="10px" fxLayoutAlign="end center">
  <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
  <sbnb-button label="Continue" (click)="progress()"></sbnb-button>
</div>
